import { daysOfTheWeekS, generalHelpers, millisecondsThreeHours } from '@monorepo/helpers';
import { FC, ReactNode, useEffect, useState } from 'react';
import { Forecast } from './Forecast';
import { Hr, Loading } from '..';
import { typeForecast, typeList, typeWeatherIcons } from '@monorepo/models';
import { Weather } from './Weather';
import { weatherServices } from 'src/services';
import * as Icons from './WeatherIcons';

const weatherIcons: typeWeatherIcons = {
    'broken clouds': <Icons.CloudIcon />,
    'clear sky': <Icons.SunIcon />,
    'drizzle': <Icons.RainIcon />,
    'few clouds': <Icons.SunBehindCloudIcon />,
    'heavy intensity rain': <Icons.CloudLightningIcon />,
    'light intensity drizzle': <Icons.RainIcon />,
    'light rain': <Icons.SunBehindRainIcon />,
    'mist': <Icons.FogIcon />,
    'moderate rain': <Icons.SunBehindRainIcon />,
    'overcast clouds': <Icons.CloudIcon />,
    'overcast-clouds': <Icons.CloudIcon />,
    'rain': <Icons.SunBehindRainIcon />,
    'scattered clouds': <Icons.SunBehindLargeCloudIcon />,
    'shower rain': <Icons.RainIcon />,
    'smoke': <Icons.FogIcon />,
    'snow': <Icons.SnowIcon />,
    'thunderstorm with heavy rain': <Icons.CloudLightningIcon />,
    'thunderstorm with light rain': <Icons.CloudLightningIcon />,
    'thunderstorm with rain': <Icons.CloudLightningIcon />,
    'thunderstorm': <Icons.CloudLightningIcon />
};

const getWeatherIcon = (key: string): ReactNode => (weatherIcons?.[key] as JSX.Element) || key;

type propsType = {
    showForecast0: boolean;
    showWeather: boolean;
};

export const WeatherAndForecast: FC<propsType> = ({ showForecast0, showWeather }) => {
    const [forecasts, setForecasts] = useState<typeForecast[]>([]);
    const [showForecast, setShowForecast] = useState<boolean>(showForecast0);
    const [weatherRightNow, setWeatherRightNow] = useState<typeList>();

    const getWeekday = (i: number) => {
        const today = new Date().getDay();
        if (i === today) {
            return 'Hoy';
        }
        if (i === today + 1 || i === today - 6) {
            return 'Mañana';
        }
        return daysOfTheWeekS[i];
    }

    useEffect(() => {
        weatherServices.Get().then(weatherAndForecast => {
            if (!weatherAndForecast) {
                return;
            }
            if (weatherAndForecast.weather) {
                setWeatherRightNow({
                    clouds: weatherAndForecast.weather.clouds,
                    dt: weatherAndForecast.weather.dt,
                    dt_txt: weatherAndForecast.weather.dt?.toString(),
                    main: weatherAndForecast.weather.main,
                    name: weatherAndForecast.weather.name,
                    pop: 0,
                    rain: weatherAndForecast.weather.rain,
                    sys: weatherAndForecast.weather.sys,
                    visibility: weatherAndForecast.weather.visibility,
                    weather: weatherAndForecast.weather.weather,
                    wind: weatherAndForecast.weather.wind
                });
            }
            if (weatherAndForecast.forecast && !!weatherAndForecast.forecast.list?.length) {
                const _forecasts = weatherAndForecast.forecast.list.map(forecast => {
                    const date = new Date(forecast.dt * 1000);
                    const shifted = new Date(date.getTime() - millisecondsThreeHours);
                    const day = shifted.getUTCDay();
                    const _forecast: typeForecast = {
                        date: {
                            dateDay: shifted.getUTCDate(),
                            day: day,
                            fullDate: generalHelpers.FormatDate(shifted),
                            hour: shifted.getUTCHours(),
                            weekday: getWeekday(day)
                        },
                        icon: getWeatherIcon(forecast.weather?.[0]?.description),
                        list: forecast,
                        pop: forecast.pop,
                        temperatures: Math.ceil((forecast.main?.temp_max + forecast.main?.temp_min) / 2),
                    };
                    return _forecast;
                });
                setForecasts(_forecasts);
            }
        });
    }, []);

    return (
        <>
        {showWeather && weatherRightNow &&
            <>
            <Weather
                chance={Math.round((forecasts[0]?.list.pop || 0) * 100)}
                feelsLike={Math.round(weatherRightNow?.main?.feels_like || 0)}
                icon={getWeatherIcon(weatherRightNow.weather?.[0]?.description)}
                location={`${weatherRightNow.name}, ${weatherRightNow.sys?.country}`}
                rain={Math.round((weatherRightNow?.rain?.['1h'] || 0) * 100)}
                temperature={Math.round(weatherRightNow?.main?.temp || 0)}
            />
            <button className={'btn btn-general-blue d-block mx-auto mt-2 mb-4'}
                onClick={() => setShowForecast(x => !x)}
                style={{ width: '250px' }}
            >
                {showForecast ? "Ocultar Pronóstico" : "Ver Pronóstico"}
            </button>
            <Hr />
            </>
        }
        {showForecast &&
            <>
            {!!forecasts?.length ?
                <Forecast forecasts={forecasts} />
                :
                <Loading mt={'30px'} />
            }
            </>
        }
        {showWeather && showForecast &&
            <Hr />
        }
        </>
    );
}
